import { ErrorHandler, Injectable } from '@angular/core';
import { Integrations as ApmIntegrations } from '@sentry/apm';
import * as Sentry from '@sentry/browser';
import { env } from '../environments/environment';

Sentry.init({
  dsn: env.production ? (window as any).SENTRY_DSN : '',
  integrations: [new ApmIntegrations.Tracing()],
  tracesSampleRate: 0.2,
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error) {
    const e = error.originalError || error;
    Sentry.captureException(e);
    throw error;
  }
}
